exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "copy-to-clipboard .clipboard-btn {\n  border-width: 0;\n  background-color: transparent;\n  color: var(--color-dovegray);\n  display: inline-block;\n}\ncopy-to-clipboard .clipboard-btn:hover {\n  background-color: transparent;\n}\ncopy-to-clipboard.copy-to-clipboard-sm .clipboard-btn {\n  margin-bottom: 3px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/utils/clipboard/copyToClipboard.component.less
// module id = 2445
// module chunks = 0